import { render, staticRenderFns } from "./ChangeKValue.vue?vue&type=template&id=22643bd4&scoped=true"
import script from "./ChangeKValue.vue?vue&type=script&lang=js"
export * from "./ChangeKValue.vue?vue&type=script&lang=js"
import style0 from "./ChangeKValue.vue?vue&type=style&index=0&id=22643bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22643bd4",
  null
  
)

export default component.exports